import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
} from '@ionic/angular/standalone';

import { addIcons } from 'ionicons';

import { isFeatureEnabled } from '@core/config/feature-flags';
import { MAIN_NAV_ICONS, MAIN_NAV_ITEMS } from '@core/constants/nav-items.constant';
import { DemoBadgeComponent } from '@core/demo/demo-badge.component';
import { ScreenStore } from '@core/stores/screen.store';

import { XBottomNavComponent } from '@infrastructure/components/common/x-bottom-nav/x-bottom-nav.component';

@Component({
  selector: 'app-shell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    RouterLinkActive,
    IonMenu,
    IonContent,
    IonList,
    IonItem,
    IonIcon,
    IonLabel,
    IonMenuToggle,
    IonRouterOutlet,
    XBottomNavComponent,
    DemoBadgeComponent,
  ],
  templateUrl: './shell.component.html',
  styleUrl: './shell.component.scss',
})
export class ShellComponent {
  protected readonly screen = inject(ScreenStore);
  protected readonly navItems = MAIN_NAV_ITEMS.filter((item) => isFeatureEnabled(item.feature));

  constructor() {
    addIcons(MAIN_NAV_ICONS);
  }
}
